import React from "react";
import ReactDOM from "react-dom";
import "./forgot-password.style.scss";
export default function ForgotPassword({
  closeIt,
  requesting,
  emailSent,
  handleSubmit,
}) {
  const [error, setError] = React.useState(false);
  const [email, setEmail] = React.useState("");
  return ReactDOM.createPortal(
    <div onClick={() => closeIt()} className="forget-password-modal-wrapper">
      <div
        onClick={(e) => e.stopPropagation()}
        className="forgot-password-modal"
      >
        <header className="">
          <span></span>
          <h4>Forgot password</h4>
          <img
            onClick={() => closeIt()}
            src="https://img.icons8.com/material-outlined/24/000000/delete-sign.png"
          />
        </header>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(email);
          }}
          className="fpm-body"
        >
          <p className="fpm-message">
            If you have an account, we'll email you a reset link.
          </p>

          <div
            className={`on-border-input ${
              emailSent.status !== null && emailSent.status && "error"
            }`}
          >
            <span>Email ID</span>
            <input
              onChange={(e) => setEmail(e.target.value)}
              name="email"
              placeholder="user@gmail.com"
              type="email"
              required
            />
            <p>No account found!</p>
          </div>
          <button>{requesting ? "Requesting..." : "Submit"}</button>
        </form>
      </div>
    </div>,
    document.body
  );
}
